import React, { useContext, useState } from 'react';

import { ContextRenegociacao } from '../../../../services/renegociacao';

import { Item, ItemContent, SimularButton } from './styles.js';
import { Spinner } from '../../../StyledComponent';
import { getExpirationDateFirstParcell } from '../expirationDateFirstParcell';

const SimularBtn = ({
  tema,
  regras,
  valorTotalAtualizado,
  handleShowSimulacao,
  contratoSelecionado,
}) => {
  const { simularRenegociacao } = useContext(ContextRenegociacao);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const btnStyle = {
    padding: 0,
    height: '44px',
    width: 'calc(100% + 4px)',
    border: 'none',
    borderRadius: '4px',
    overflow: 'hidden',
  };

  const handleSubmit = async () => {
    const Valor_Fatura = valorTotalAtualizado;
    const Numero_de_Parcelas = Number(regras.numeroParcelas.split('x')[0]);
    const Numero_Empresa_UAU =
      contratoSelecionado?.contrato?.empresaVendaCarteira ||
      contratoSelecionado?.contrato?.empresa;
    const Id_Obra =
      contratoSelecionado?.contrato?.obraVendaCarteira ||
      contratoSelecionado?.contrato?.obra;
    const CPF_CPNJ_Cliente = contratoSelecionado?.contrato?.cpfCnpjCliente;
    const Numero_de_Venda =
      contratoSelecionado?.contrato?.numeroVendaVendaCarteira ||
      contratoSelecionado?.contrato?.numeroVenda;
    const Valor_Entrada = regras?.entrada;

    const Data_Vencimento_Entrada = regras?.vencimentoEntrada.date;
    const Data_Vencimento_Primeira_Parcela =
      getExpirationDateFirstParcell(regras);

    setIsLoading(true);
    try {
      await simularRenegociacao({
        Valor_Fatura,
        Numero_de_Parcelas,
        Numero_Empresa_UAU,
        Id_Obra,
        CPF_CPNJ_Cliente,
        Numero_de_Venda,
        Valor_Entrada,
        Data_Vencimento_Entrada,
        Data_Vencimento_Primeira_Parcela,
      });
      handleShowSimulacao();
    } catch (e) {
      console.error(e);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const DISABLE_SIMULAR_BTN =
    !regras.entrada ||
    !regras.vencimentoEntrada ||
    !regras.numeroParcelas ||
    !regras.vencimentoParcelas ||
    !regras?.mesVencimentoPrimeiraParcela?.nome ||
    regras.entrada > regras.valorMaximo ||
    regras.entrada < regras.valorMinimoEntrada ||
    isLoading ||
    error;

  return (
    <>
      <Item>
        <span style={{ color: '#ffffff' }}>placeholder</span>
        <ItemContent style={btnStyle}>
          <SimularButton
            onClick={handleSubmit}
            disabled={DISABLE_SIMULAR_BTN}
            tema={tema}
            id={'btnSimularRenegociacao'}
          >
            simular renegociação
            {isLoading && <Spinner />}
          </SimularButton>
        </ItemContent>
      </Item>
      {error && (
        <p>
          Estamos com um problema no sistema, por favor tente novamente mais
          tarde!
        </p>
      )}
    </>
  );
};

export default SimularBtn;
